import React, { useState } from "react";
import "../style/brows.scss";
import "../style/home.scss";
import SliderBeforeAfter from "../components/SliderBeforeAfter";
import ActionSection from "../components/ActionSection";
import dan1 from "../img/brows/PRVIDAN.webp";
import dan2 from "../img/brows/DRUGIDAN.webp";
import dan3 from "../img/brows/TRECIDAN.webp";
import dan4 from "../img/brows/CETVRT.webp";
import dan5 from "../img/brows/PET.webp";
import dan6 from "../img/brows/SEST.webp";

export default function Brows() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      id: 1,
      question: "Dan 1",
      answer:
        "Vaše obrve će izgledati savršeno, ali intenzivnije i tamnije nego što će biti nakon potpunog zarastanja. Može doći do blagog crvenila i otoka.",
      src: dan1,
    },
    {
      id: 2,
      question: "Dan 2-4",
      answer:
        "Obrve će izgledati još tamnije što je potpuno normalno jer se pigment stabilizuje u koži.",
      src: dan2,
    },
    {
      id: 3,
      question: "Dan 5-7",
      answer:
        "Počinje perutanje kože, što je prirodan proces zarastanja. Obrve mogu izgledati neujednačeno ili svetlije, ali to je deo procesa. Moguć je i svrab, ali se savetuje da ne dirate obrve kako ne biste oštetili pigment. Ne čupkati obrve!",
      src: dan3,
    },
    {
      id: 4,
      question: "Dan 8-14",
      answer:
        "Obrve će postati veoma svetle, delimično nestati, ali to je privremeno dok se pigment ne stabilizuje.",
      src: dan4,
    },
    {
      id: 5,
      question: "Dan 15-30",
      answer:
        "Većina boje će se vratiti, obrve će dobiti prirodniji izgled, a nepravilnosti će se smanjiti. Preporučuje se da u ovom periodu zakazujete termin za korekciju.",
      src: dan5,
    },
    {
      id: 6,
      question: "Nedelja 4-6",
      answer:
        "Obrve su potpuno zarasle, a boja se stabilizovala. Rezultat je suptilan, prirodan izgled sa mekom puderastom teksturom. Korekcija je obavezna kako bi se dodatno popunile eventualne praznine i poboljšao krajnji rezultat.",
      src: dan6,
    },
  ];
  return (
    <>
      <div className="container banner">
        <div className="wrapper p-30">
          <div className="title-box">
            <h1 data-aos="fade-down" className="title">Puder Obrve – Savršen Prirodan Izgled</h1>
            <h2 data-aos="fade-down" className="subtitle">
              Puder Obrve – Prirodna Lepota sa Dugotrajnim Efektom
            </h2>
          </div>
        </div>
      </div>

      <section className="brows wrapper">
        <h3 data-aos="fade-right">Zašto Odabrati Puder Obrve?</h3>
        <p data-aos="fade-right">
          Puder obrve su inovativna tehnika trajne šminke koja se bazira na
          postepenom nanošenju boje specijalizovanom mašinom za tetoviranje. Za
          razliku od klasičnog iscrtavanja, ova metoda pruža nežan, puderast
          izgled koji podseća na diskretno nanetu senku, bez oštrih ivica i
          previše izraženih linija. Idealne su za osobe koje žele da poboljšaju
          prirodni oblik i punoću svojih obrva, a da pritom zadrže suptilan i
          elegantan izgled.
        </p>

        <h3 data-aos="fade-right">Prednosti Puder Obrva</h3>
        <ul>
          <li data-aos="fade-right">
            Prirodni efekat – Blago senčenje osigurava mekoću i nežan izgled, bez preterano naglašenih linija.
          </li>
          <li data-aos="fade-right">
            Dugotrajni rezultati – Održavaju se mesecima, što znači da ne morate
            svakodnevno popunjavati obrve.
          </li>
          <li data-aos="fade-right">
            Minimalno održavanje – Bez potrebe za čestim korekcijama ili
            svakodnevnim crtanjem obrva.
          </li>
          <li data-aos="fade-right">
            Prilagođeno svakom tipu lica – Oblik obrva se oblikuje prema vašim crtama lica i željenom izgledu.
          </li>
        </ul>

        <h3 data-aos="fade-right">Kako Izgleda Postupak?</h3>
        <p data-aos="fade-right">
          Proces izrade puder obrva je potpuno bezbedan i precizan. Nakon
          konsultacija sa klijentom, biramo boju i oblik koji najbolje odgovara
          njegovom licu i prirodnoj nijansi obrva. Zatim, pomoću profesionalne
          mašinice, nežno unosimo pigment između epiderma i derma sloja kože,
          kreirajući efekat blago senčenih obrva.
        </p>

        <h3 data-aos="fade-right">Koraci Tretmana:</h3>
        <ol>
          <li data-aos="fade-up">
            <b>1</b>
            Konsultacije i analiza – Razgovor sa klijentom i odabir idealnog
            oblika i boje.
          </li>
          <li data-aos="fade-up">
            <b>2</b>
            Priprema i oblikovanje – Skiciranje željenog oblika i definisanje
            kontura.
          </li>
          <li data-aos="fade-up">
            <b>3</b>
            Nanošenje pigmenta – Precizno nanošenje boje u slojevima kako bi se
            postigao što prirodniji izgled.
          </li>
          <li data-aos="fade-up">
            <b>4</b>
            Finalna provera i saveti za negu – Nakon tretmana, dobijate detaljne
            instrukcije za negu obrva.
          </li>
        </ol>

        <SliderBeforeAfter />

        <h3 data-aos="fade-right">Održavanje i Briga Nakon Tretmana</h3>
        <p data-aos="fade-right">
          Kako biste očuvali postojanost boje nakon tretmana, preporučuje se da
          tokom prve dve nedelje izbegavate fizičke aktivnosti, uključujući
          saunu i ne nanosite kozmetiku na tretiranu regiju. U prvih mesec dana
          nakon tretmana potrebno je izbegavati izlaganje tretirane regije UV
          zracima, kao što su sunce i solarijum, kao i kupanje na javnim
          mestima.
        </p>

        <h3 data-aos="fade-right">Šta Očekivati Tokom Zarastanja</h3>
        <div className="wrapper faq">
          <div className="faq-text">
            {faqData.map((item, index) => (
              <div className="gues_box" key={index}>
                <div>
                  <div
                    data-aos="fade-left"
                    className="ques"
                    onClick={() => toggleQuestion(index)}
                  >
                    <div className="ques_text">
                      <div className="id_ques">{item.id}</div>
                      <p>{item.question}</p>
                    </div>
                    <span>&#9660;</span>
                  </div>

                  {openIndex === index && (
                    <div data-aos="fade-left" style={{padding: 10}}>
                      <p
                        className={`ans_text ${
                          openIndex === index ? "open" : ""
                        }`}
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      />
                      <img className="ans_img" src={item.src} alt="Proces zarastanja obrva - Heli Brows" />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="reviews">
          <h3 data-aos="fade-right">Recenzije Naših Klijenata</h3>

          <div className="review">
            <h4 data-aos="fade-right">Natalija Mirčetić</h4>
            <blockquote data-aos="fade-right">
            „Dugo sam razmisljala da uradim puder obrve, ali se nikako nisam usudjivala jer nisam imala 100% poverenje ni
            u koga, dok nisam naisla na heli brows. Iskreno, nikad lepse se u zivotu nisam osecala, nego sada sa mojim
            novim obrvama. Prelepe su,prirodne, da ja sada bez problema izadjem bez sminke, a opet izgledam lepo i
            sredjeno. Svaka preporuka.“
            </blockquote>
          </div>

          <div className="review">
            <h4 data-aos="fade-right">Nataša Miletić</h4>
            <blockquote data-aos="fade-right">
            „Helena je izuzetno prijatna i profesionalna u ovome sto radi. Ceo zivot mucim muku sa obrvama i nikad nisam
smogla snage da uradim, ali nakon porodjaja sam shvatila da je vreme da malo poradim na sebi i jako sam
srecna sto je to bilo kod Helene. Nakon uradjenih puder obrva kod nje dobila sam samopouzdanje koje nikad
nisam imala, a to je da na ulicu izadjem bez 15 minuta crtanja obrva. Zaista je nasla najbolji oblik za moje lice i
ucinila da izgledam kao potpuno druga osoba u onom najbolje mogucem smislu.“
            </blockquote>
          </div>

          <div className="review">
            <h4 data-aos="fade-right">Milica Bukumirović</h4>
            <blockquote data-aos="fade-right">
            „Nikada nisam razmišljala o tome da radim nešto sa svojim obrvama, ali sada ne mogu da verujem koliko su
puder obrve promenile moj izgled. Moj pogled je otvoreniji, lice deluje nežnije i sve izgleda potpuno prirodno.
Osećam se svežije, ženstvenije i sigurnije u sebe. Ono što Helena radi nije samo posao , to je umetnost,
strpljenje i pažnja posvećena svakom detalju. Od samog početka bila sam u sigurnim rukama, svaki potez je bio
precizan, nežan i u potpunosti prilagođen meni. Ceo proces je bio prijatan i bezbolan, a rezultat je prevazišao
sva moja očekivanja. Hvala ti od srca na ovoj transformaciji! Preporučujem svima koji razmišljaju o puder
obrvama – nećete se pokajati. Ovo je investicija u sebe koju svaka žena zaslužuje.“
            </blockquote>
          </div>

          <div className="review">
            <h4 data-aos="fade-right">Verica Milenković (81 god.)</h4>
            <blockquote data-aos="fade-right">
              „Nisam mislila da ću u svojim godinama poželeti da uradim nešto za sebe na ovaj način, ali sada mogu da kažem
– ovo je jedna od najboljih odluka koje sam donela! Godine su učinile svoje, obrve su mi postale retke i svetle, a
sada su ponovo tu, savršeno oblikovane i potpuno prirodne. Iskreno, nisam očekivala da ću se ovako dobro
osećati nakon jedne &quot;male&quot; promene, ali ovo je za mene velika stvar. Oduševljena sam profesionalnošću,
pažnjom i nežnošću tokom celog tretmana. Od srca hvala na ovoj divnoj promeni! Svim damama, bez obzira na
godine, poručujem! Nikad nije kasno da se obradujete i učinite nešto lepo za sebe.“
            </blockquote>
          </div>

          <div className="review">
            <h4 data-aos="fade-right">Stojanka Boljevčić</h4>
            <blockquote data-aos="fade-right">
              „Helena je izuzetno profesionalna i prijatna. Obrve su ispale tačno onako kako sam želela – prirodne i savršeno oblikovane. Proces je bio potpuno bezbolan, a rezultat je nadmašio moja očekivanja. Sigurno ću se vratiti i toplo preporučujem svima!“
            </blockquote>
          </div>
        </div>
      </section>

      <div data-aos="zoom-in">
        <ActionSection />
      </div>
    </>
  );
}
